var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_6442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2706 0.624512C1.15539 0.624512 1.04514 0.642843 0.941051 0.675648L7.48651 6.95406C7.78861 7.24335 8.21901 7.24335 8.5206 6.95406L15.0547 0.675648C14.9506 0.642843 14.8403 0.624512 14.7251 0.624512H1.2706ZM0.355824 1.12451C0.245517 1.29507 0.179688 1.49634 0.179688 1.71542V8.98815C0.179688 9.20431 0.242516 9.40423 0.350142 9.57337L4.66832 5.25518L0.355824 1.12451ZM15.6399 1.12451L11.3331 5.26088L15.6456 9.57337C15.7532 9.40423 15.8161 9.20431 15.8161 8.98815V1.71542C15.8161 1.49634 15.7502 1.29507 15.6399 1.12451ZM5.19105 5.76088L0.929687 10.0222C1.03721 10.0575 1.15098 10.0791 1.2706 10.0791H14.7251C14.8448 10.0791 14.9585 10.0575 15.0661 10.0222L10.8047 5.76088L9.0206 7.47678C8.45245 8.02177 7.55484 8.02102 6.98651 7.47678L5.19105 5.76088Z",
    fill: "#F27C06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_6442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    fill: "white",
    transform: "translate(0 0.26123)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ff28a767b31b8efcaaf0025c3e755307.svg";
export { ForwardRef as ReactComponent };